import RadioButton from "../../components/radioButton/RadioButton";
import React, {useState} from "react";
import TextArea from "../../components/TextArea/TextArea";
import Button from "../../components/Button/Button";
import FeedbackService from "../../services/FeedbackService";
import Spinner from "../../components/spinner/Spinner";

function Feedback(props){

    const [state,setState] = useState({assistentiTrovati:"",feedback:""})
    const [showSpinner,setShowSpinner] = useState(false)
    function onChange(id,value){
        let newState = {...state}
        let newId = /\d/.test(id) ? id.replace(new RegExp("[0-9]", "g"), "") : id
        newState[newId] = value
        setState(newState)
    }

    function chiusuraModale(){
        setState({assistentiTrovati:"",feedback:""})
    }

    function salvaFeedback(){
        setShowSpinner(true)
        let feedback = {...state}
        FeedbackService.salvaFeedback(feedback).then(res => {
            setState({assistentiTrovati:"",feedback:""})
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore POST Feedback: "+reason)
            setShowSpinner(false)
        })
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"row"} style={{alignItems:"center"}}>
                <div className={"col-9"}>
                    <span>
                        Hai trovato Assistenti da contattare tramite il Registro?
                    </span>
                </div>
                <div className={"col-1"}>
                    <RadioButton id={"assistentiTrovati1"}
                                 text={"Si"}
                                 onChange={(event) => onChange(event.target.id, event.target.value)}
                                 value={"1"}
                                 checked={state && state.assistentiTrovati && state.assistentiTrovati === "1"}
                    />
                </div>
                <div className={"col-1"}>
                    <RadioButton id={"assistentiTrovati2"}
                                 text={"No"}
                                 onChange={(event) => onChange(event.target.id, event.target.value)}
                                 value={"2"}
                                 checked={state && state.assistentiTrovati && state.assistentiTrovati === "2"}
                    />
                </div>
            </div>
            <div>
                <span>Segnalazioni e suggerimenti:</span>
                <TextArea id={"feedback"} rows={"5"} ariaLabel={"Segnalazioni e suggerimenti"}
                          value={state && state.feedback ? state.feedback : ""}
                          onChange={(event) => onChange(event.target.id, event.target.value)}
                />
            </div>
            <div className={"row"} style={{marginTop: "1rem", marginBottom: "1rem"}}>
                <div className={"col-6"}>
                    <Button
                        id={"chiudi"}
                        typeButton={"White"}
                        text={"Chiudi"}
                        style={{height: "45px", width: "180px"}}
                        dataDismiss="modal"
                        onClick={chiusuraModale}
                    />
                </div>
                <div className={"col-6"}>
                    <Button
                        id={"invia"}
                        typeButton={"Blue"}
                        disabled={!state.assistentiTrovati}
                        text={"Invia"}
                        style={{height: "45px", width: "180px",float:"right"}}
                        dataDismiss="modal"
                        onClick={salvaFeedback}
                    />
                </div>
            </div>
        </div>
    )


}
export default Feedback